/** Exact adult Parent Guide contract. Public exposure requires owner approval. */
export const PARENT_GUIDE_ID = "62e2e56e-be9b-5182-96f4-8447bebac4d2";
export const PARENT_GUIDE_SLUG = "parent-gaming-digital-safety";
export const PARENT_GUIDE_LAUNCH_READY = true;
export const isParentGuide = (id?: string | null, slug?: string | null) =>
  id === PARENT_GUIDE_ID && slug === PARENT_GUIDE_SLUG;
